export class Alert {
    type: AlertType;
    message: any;
    removedAfter: number = 6000;
}

export enum AlertType {
    Success,
    Error,
    Info,
    Warning,
    Publish,
    Unpublish
}
